import Reveal from "./Reveal";

const CHAPTERS = [
  { n: "01", title: "Craftsmanship", text: "Every piece is made with precision and care — cut, joined, polished and finished by hands that have done it for decades." },
  { n: "02", title: "Integrity", text: "Honest advice, transparent communication and fair practice. We earn trust; we never chase volume." },
  { n: "03", title: "Personalization", text: "No two homes are alike. Every client deserves furniture designed entirely around their life and their space." },
  { n: "04", title: "Quality", text: "We never compromise — not on hardwoods, not on construction, not on finishing. Built to be inherited." },
  { n: "05", title: "Evolution", text: "We embrace innovation while preserving the traditional Rajasthani craftsmanship that defines us." },
];

export default function Manifesto() {
  return (
    <section id="story" data-testid="manifesto-section" className="bg-ivory py-28 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">The Manifesto</p>
          <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight max-w-3xl">
            Five promises, <em className="text-oxblood font-light">kept daily</em> since 2013.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.06}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline border-t border-oxblood/20 py-10 md:py-14 transition-all duration-500 hover:pl-4 md:hover:pl-8"
              >
                <span className="col-span-3 md:col-span-2 font-display text-4xl md:text-6xl text-oxblood/30 group-hover:text-brass transition-colors duration-500">
                  {c.n}
                </span>
                <h3 className="col-span-9 md:col-span-4 font-display text-2xl md:text-4xl text-oxblood-ink">
                  {c.title}
                </h3>
                <p className="col-span-12 md:col-span-6 text-ink/70 font-light leading-relaxed text-base max-w-xl mt-3 md:mt-0">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-oxblood/20" />
        </div>
      </div>
    </section>
  );
}
